import { css } from "lit"

export const emailFooterStyles = css`
  /* Email signup */
  .email-footer {
    background: #f3f3f1;
    justify-content: center;
    align-items: center;
  }

  .email-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    width: 100%;
    padding: 1.5rem 2.5rem;
  }

  .email-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.25rem;
  }

  .email-form {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
  }

  .email-title {
    font-size: 1.25rem;
  }

  .email-input {
    flex: 1;
    border: 1px solid #e5e7eb;
    color: #100b00;
    background: inherit;
    border-radius: 0.175rem;
    font-size: 0.75rem;
    line-height: 1rem;
    text-indent: 0.75rem;
    height: 1.75rem;
    font-family: inherit;
  }

  .email-input::placeholder {
    color: #949494;
  }

  .email-button {
    display: inline-flex;
    background: inherit;
    color: #647a1c;
    border: 1px solid #647a1c;
    border-radius: 0.175rem;
    text-decoration-line: none;
    cursor: pointer;
    font-size: 0.6rem;
    line-height: 1rem;
    text-transform: uppercase;
    height: 1.75rem;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    font-family:
      Avenir LT W01_85 Heavy1475544,
      Avenir,
      sans-serif;
    letter-spacing: 0.1em;
    font-weight: 700;
    opacity: 0.7;
    flex-shrink: 0;
    width: 4.5rem;
  }

  @media (min-width: 768px) {
    .email-container {
      flex-direction: row;
      justify-content: center;
      max-width: 64rem;
      margin: 0 auto;
    }

    .email-form {
      width: 50%;
    }

    .email-title {
      margin-right: 1rem;
    }
  }
`
